import {
  IconAnalytics,
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconCar,
  IconChainLink,
  IconChainLinkGray,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconPenSquare,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/retailOffice/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/retailOffice/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/retailOffice/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/retailOffice/video/sub/rtlsVideo3.mp4';

import image1 from '@src/assets/images/solution/retailMobile/img/1.avif';
import image2 from '@src/assets/images/solution/retailMobile/img/2.avif';
import image3 from '@src/assets/images/solution/retailMobile/img/3.avif';
import image4 from '@src/assets/images/solution/retailMobile/img/4.avif';
import image5 from '@src/assets/images/solution/retailMobile/img/5.avif';
import image6 from '@src/assets/images/solution/retailMobile/img/6.avif';
import image7 from '@src/assets/images/solution/retailMobile/img/7.avif';
import image8 from '@src/assets/images/solution/retailMobile/img/8.avif';
import { recommendationEdge, recommendationSwitch, retailMobile1, retailMobile2 } from '@assets/images/solution/recommendation';
import recommendation from '../common/recommendation';

export default {
  type: '리테일 솔루션',
  banner: {
    title: '스마트폰 체험은 자유롭게, 전시 보안은 자동으로 관리하세요',
    desc: '무선 태그 기술로 스마트폰 체험을 자유롭게 제공하고 전시 보안을 자동으로 유지합니다',
  },

  recommend: {
    title: '전시 제품의 위치를 자동 추적하고 이탈 시 경고를 전송합니다',
    desc: '스마트폰에 부착된 Safe Tag와 무선 충전 크래들이 연동되어, 제품의 체험 상태와 위치 정보를 동시에 관리합니다',
    labels: {
      desktop: [
        {
          img: retailMobile1,
          data: recommendation.safeTag,
        },
        {
          img: retailMobile2,
          data: recommendation.safeCradle,
        },
        {
          img: recommendationEdge,
          data: recommendation.edgeRtls,
        },
        {
          img: recommendationSwitch,
          data: recommendation.switch,
        },
      ],
      mobile: [
        {
          data: recommendation.safeTag,
        },
        {
          data: recommendation.safeCradle,
        },
        {
          data: recommendation.edgeRtls,
        },
        {
          data: recommendation.switch,
        },
      ],
    },
  },

  func: [
    {
      theme: '고객 체험 흐름에 맞춘 스마트 전시 환경을 구축하세요',
      title: '자유로운 체험이 가능한 모바일 매장',
      desc: '고객은 스마트폰을 손에 들고 자유롭게 조작하며 제품을 직접 체험할 수 있습니다. 와이어 고정 없이도 보안이 유지되도록 설계되어 사용 제약 없이 실사용에 가까운 경험을 제공합니다.',
      sub1: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub2: '높은 정확도 제공',
      icon2: IconRulerGray,
      image: image1,
    },
    {
      title: '사이니지 연동 정보 제공',
      desc: '단말기를 들어 올리면 해당 제품의 정보가 사이니지 화면에 자동으로 표시됩니다. 고객은 안내 없이도 주요 기능을 자연스럽게 확인할 수 있으며, 매장 운영자는 인력 없이도 체험과 정보 전달을 동시에 제공할 수 있습니다. ',
      sub1: '실시간 현황 파악',
      icon1: IconClockGray,
      sub2: '빠른 데이터 연동',
      icon2: IconShareGray,
      image: image2,
    },
    {
      title: '이탈 감지 기반 관리자 알림',
      desc: '단말기가 지정된 위치를 벗어나면 태그에서 경보가 울리고 관리자에게 알림이 전송됩니다. 자유로운 체험을 방해하지 않으면서도 보안 상황에 즉시 대응할 수 있습니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image3,
    },
    {
      title: '체험 데이터를 통한 선호 단말기 분석',
      desc: '단말기 픽업 횟수와 비교 기능 사용 기록이 자동 저장되어 운영에 활용됩니다. 체험 데이터를 분석해 인기 모델을 파악하고 제품 배치에 반영할 수 있어, 마케팅 전략 수립에 유용하게 활용됩니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      theme: '단말기 전시를 위한 전용 태그와 크래들을 소개합니다',
      title: '자유로운 체험을 위한 무선 태그',
      desc: 'Safe Tag는 단말기에 부착되어 전원을 공급하고 동시에 위치를 추적할 수 있는 전용 태그입니다. 와이어 없이도 보안이 유지되며 고객은 제한 없이 제품을 손에 들고 자유롭게 체험할 수 있습니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      title: '모든 스마트폰에 호환되는 범용 설계',
      desc: 'Safe Tag는 제조사나 기종에 관계없이 대부분의 스마트폰에 부착할 수 있도록 설계되어 있습니다. 하나의 태그로 다양한 단말기를 통일된 방식으로 전시할 수 있어 운영 일관성과 적용 범위가 넓어집니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image6,
    },
    {
      title: '전시와 보안을 함께 완성하는 크래들',
      desc: '크래들은 태그와 정밀하게 맞물려 전력을 안정적으로 공급하며 단말기의 위치를 실시간으로 감지할 수 있도록 설계되어 있습니다. 전시 기기를 무선으로 충전하면서 동시에 보안 반경 내 이동을 관리할 수 있어 운영 안정성과 설치 효율을 함께 만족시킵니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image7,
    },
    {
      title: '자연스러운 거치를 위한 최적의 도킹 각도 설계',
      desc: '크래들은 단말기를 자연스럽게 들어 올리고 다시 거치할 수 있도록 15도 각도로 설계되어 있습니다. 체험이 반복되더라도 위치가 안정적으로 맞물려 매장 환경의 일관된 체험 흐름을 유지할 수 있습니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image8,
    },
  ],

  subfunc: {
    title: '기능 요약',
    desc: '효율적인 재고 관리, 시간 및 비용 절감, 투명성 및 추적성 등 다양한 장점이 있습니다.<br/>최적의 근무 환경을 조성하고 최고의 효율을 만들어 낼 수 있도록, 오브로는 다음과 같은 기능들을 추가로 제공합니다.',
    data: [
      {
        icon: IconRoute, // 모바일 체험 → 사용자 이동 기반 체험 의미
        title: '자유로운 모바일 체험',
        desc: 'Safe Tag로 제품 위치를 실시간 추적해 체험과 보안을 동시에 유지합니다.',
      },
      {
        icon: IconLayers, // 사이니지 연동 → 정보 표출/디스플레이 → Layers 재사용
        title: '사이니지 연동',
        desc: '스마트폰을 들면 해당 정보가 사이니지에 자동 표출되어 안내 인력이 필요 없습니다.',
      },
      {
        icon: IconWarning, // 위치 이탈 → 경고 알림 의미
        title: '위치 이탈 경고 전송',
        desc: '제품이 지정 위치를 벗어나면 관리자에게 즉시 경고 알림을 전송합니다.',
      },
      {
        icon: IconAnalytics, // 체험 분석 → Analytics: 데이터 분석
        title: '체험 데이터 분석',
        desc: '픽업 횟수와 체류 시간을 분석해 인기 제품과 비교 조합을 시각화합니다.',
      },
      {
        icon: IconSearch, // 태그 호환성 → Search: 범용성과 확장 탐색 의미
        title: '범용 태그 호환성',
        desc: '전용 태그가 전력 공급과 위치 추적을 동시에 지원합니다.',
      },
      {
        icon: IconCar, // 무선 충전 → 충전 관련 아이콘 없으므로 Car 임시 재사용
        title: '무선충전 크래들',
        desc: '크래들에 거치한 상태로 충전과 위치 관리가 동시에 가능해 유지관리가 편리합니다.',
      },
      {
        icon: IconLayers, // 도킹 각도 → 물리적 정렬/구성 → Layers 재사용
        title: '도킹 각도 설계',
        desc: '15도 각도로 설계된 크래들이 반복 체험에도 전시 정렬감을 유지해줍니다.',
      },
      {
        icon: IconSearch, // 설치 구조 → 유연한 구성 의미로 Search 재사용
        title: '간편한 설치 구조',
        desc: 'Safe Tag와 크래들은 배선 없이 설치되어 매장 변경에도 유연하게 대응합니다.',
      },
    ],
  },

  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'logisticsAsset',
    },
    {
      data: 'manufacturingSteel',
    },
    {
      data: 'blogOffice',
    },
    {
      data: 'blogRTLS',
    },
  ],
};
